module.exports = __webpack_public_path__ + "img/gruppo_mail_invoiceweb.2a3038fc.png";